module.exports = __webpack_public_path__ + "img/hero_article.bb1bdceb.png";